import { getFileExtension } from "./getFileExtension"

export const allowedFiletypeHandler = (extensionArray, filename) => {
    const extension = getFileExtension(filename)
    if(extensionArray.includes(extension.toLowerCase())) {
        return true
    } else {
        return false
    }
}